// Path kept for compatibility: this now returns every run that has store POGs,
// not only finished ones, so the dropdown can offer every selectable version.
export const RouteGetMerchflow_merchflowId_StorePogTriggerAllFinished =
  "/merchflow/:merchflowId/store-pog-trigger/all-finished";

export type ResponseGetMerchflow_merchflowId_StorePogTriggerAllFinished =
  MerchflowStorePogTrigger[];

export type StorePogTriggerType = "FLOW_UPDATE" | "STORE_PROP" | "COPY_TO_STORES";

/**
 * Addresses the generations that have no `store_pog_trigger` row — CSV/PSA
 * imports, merchflow duplicates and simulations. Used both as an option value
 * here and as a `store_pog_trigger_id` filter on the store list.
 */
export const NO_STORE_POG_TRIGGER = 0;

export interface MerchflowStorePogTrigger {
  /**
   * 0 for generations with no trigger — imports, duplicates, simulations —
   * matching how OneStoreView reports them on the store rows.
   */
  store_pog_trigger_id: number;
  created_at: string;
  /** Null on legacy trigger rows and on generations with no trigger. */
  trigger_type: StorePogTriggerType | null;
  /** Null while the run is still in progress. */
  finished_at: string | null;
}
